import { createContext, useContext, type ReactNode } from 'react'

/**
 * Whether the active canvas has finished its initial hydration (RFC-0974
 * app-health follow-up, §5.5). Used to classify a canvas asset load's `trigger`:
 * assets whose source is assigned BEFORE the canvas first becomes interactive
 * are `canvas_hydration` (opening/navigating); assets assigned AFTER are
 * `post_generation`. WorkspacePageV2 provides a latch that turns true once the
 * current canvas has first become interactive (reset per canvas). Default false
 * (outside a workspace ⇒ treated as hydration; asset events only emit inside a
 * project anyway).
 */
const CanvasHydrationContext = createContext<boolean>(false)

export function CanvasHydrationProvider({
  hydrated,
  children,
}: {
  hydrated: boolean
  children: ReactNode
}) {
  return (
    <CanvasHydrationContext.Provider value={hydrated}>{children}</CanvasHydrationContext.Provider>
  )
}

/** Read the current canvas hydration latch (false when outside a workspace). */
export function useCanvasHydrated(): boolean {
  return useContext(CanvasHydrationContext)
}
